import { Filter } from '../requests/products/product.types'
import {
  OPEN_HAMBURGER,
  SET_IS_ADMIN,
  CLOSE_HAMBURGER,
  SIGN_IN,
  SIGN_OUT,
  SET_DOCID,
  SET_PRODUCT,
  SET_USER,
  RESET,
  ADD_PENDING_DELETION,
  REMOVE_PENDING_DELETION,
  TOGGLE_LIFE_WEEK,
} from './types'

export type MiscState = {
  isAdmin: boolean
  uid: null | string
  token: null | string
  openHamburger: boolean
  docId: null | string
  product: null | string
  user: null | any
  pendingDeletion: string[]
  customFilters: Filter[]
  lifeWeek: {
    discarded: boolean
    netPrice: boolean
  }
}

const INITIAL_STATE: MiscState = {
  isAdmin: false,
  uid: null,
  token: null,
  openHamburger: false,
  docId: null,
  product: null,
  user: null,
  pendingDeletion: [],
  customFilters: [],
  lifeWeek: {
    discarded: false,
    netPrice: false,
  },
}

const reducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case SET_IS_ADMIN:
      return { ...state, isAdmin: action.payload }
    case SIGN_IN:
      return { ...state, uid: action.uid, token: action.token }
    case SIGN_OUT:
      return { ...state, uid: null, token: null }
    case OPEN_HAMBURGER:
      return { ...state, openHamburger: true }
    case CLOSE_HAMBURGER:
      return { ...state, openHamburger: false }
    case SET_DOCID:
      return { ...state, docId: action.docId }
    case SET_PRODUCT:
      return { ...state, product: action.product }
    case SET_USER:
      return { ...state, user: action.data }
    case RESET:
      return INITIAL_STATE
    case ADD_PENDING_DELETION:
      return { ...state, pendingDeletion: [...state.pendingDeletion, action.pendingDeletion] }
    case REMOVE_PENDING_DELETION:
      return {
        ...state,
        pendingDeletion: [...state.pendingDeletion.filter(item => item !== action.pendingDeletion)],
      }
    case TOGGLE_LIFE_WEEK:
      return {
        ...state,
        lifeWeek: { ...state.lifeWeek, [action.chartId]: !state.lifeWeek[action.chartId] },
      }

    default:
      return state
  }
}

export default reducer
